
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Disclaimer extends Vue {
  modal_class: string;

  constructor() {
    super();
    this.modal_class = "white-disclaimer-modal hide";
  }

  /**
   * Externally called to show the modal.
   */
  show() {
    this.modal_class = "white-disclaimer-modal show";
  }

  /**
   * Called from the close button to close the modal.
   */
  close() {
    this.modal_class = "white-disclaimer-modal hide";
  }
}
